import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f67a8e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-mod-pass-page" }
const _hoisted_2 = { class: "login-box" }
const _hoisted_3 = { class: "card card-outline card-primary" }
const _hoisted_4 = { class: "card-header text-center" }
const _hoisted_5 = { class: "text-gray text-left" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("首次登入请修改密码，新密码最少8位")
const _hoisted_7 = { class: "text-gray text-left" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("必须同时包含大小写字母和数字")
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-7" }, null, -1))
const _hoisted_12 = { class: "col-5" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 修改 ")

export function render(_ctx, _cache) {
  const _component_app_background_images = _resolveComponent("app-background-images")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_button = _resolveComponent("app-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_background_images),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.siteTitle), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_svg_icon, {
              name: "checkmark-sharp",
              class: "mr-1"
            }),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_svg_icon, {
              name: "checkmark-sharp",
              class: "mr-1"
            }),
            _hoisted_8
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("form", {
            onSubmit: _cache[4] || (_cache[4] = _withModifiers((...args) => (_ctx.loginModPass && _ctx.loginModPass(...args)), ["prevent"]))
          }, [
            _createVNode(_component_app_input, {
              icon: "person",
              class: "mb-3",
              type: "text",
              placeholder: "账户",
              autocomplete: "on",
              readonly: true,
              modelValue: _ctx.username,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.username) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              icon: "key",
              class: "mb-3",
              type: "password",
              placeholder: "密码",
              autocomplete: "off",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.password) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              icon: "key",
              class: "mb-3",
              type: "password",
              placeholder: "新密码",
              autocomplete: "off",
              modelValue: _ctx.passwordNew,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.passwordNew) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_app_input, {
              icon: "key",
              class: "mb-3",
              type: "password",
              placeholder: "确认密码",
              autocomplete: "off",
              modelValue: _ctx.passwordConfirm,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.passwordConfirm) = $event))
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_app_button, {
                  class: "btn-primary",
                  type: "submit",
                  block: "true",
                  loading: _ctx.isAuthLoading
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}